<div class="col-md-8">
  <div *ngFor="let chip of chips; let i = index" class="d-inline-block rounded border border-primary m-1 p-1">
    {{chip}}
    <button class="btn btn-danger" type="button" aria-label="remove" (click)="remove(i)">
      <em class="fa fa-times"></em>
    </button>
  </div>
</div>
